/** Utah's words for opening.ts: the one business type that is a Utah program, not the health department's. */
export const OPENING_UT = {
  /** Cottage food (shelf-stable food from home) is registered by the state agriculture department (Utah: UDAF), not the health department; the note says so. */
  cottageFoodNote: "Cottage food is registered by the Utah Department of Agriculture and Food, not the health department. CleanCleaver doesn't run that program; UDAF's page has the steps.",
  /** The state agriculture department's cottage food page. */
  cottageFoodLink: "https://ag.utah.gov/regulatory-services/cottage-food-production/",
} as const;
